import { render, staticRenderFns } from "./UserRoleAndSubscriptionDialog.vue?vue&type=template&id=51929dc2&"
import script from "./UserRoleAndSubscriptionDialog.vue?vue&type=script&lang=js&"
export * from "./UserRoleAndSubscriptionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports